<template>
  <el-dialog :title="form.id?'编辑城市公司':'添加城市公司'" :visible.sync="formVisible" :close-on-click-modal="false" width="1000px">
    <el-form ref="dataForm" label-position="right" :rules="formRules" :model="form" size="small" label-width="130px">

      <el-form-item label="城市公司：" prop="name">
        <el-input v-model="form.name" placeholder="请输入城市公司" />
      </el-form-item>
      <!-- <el-form-item label="大区：" prop="areaId">
        <el-select v-model="form.areaId" placeholder="请选择大区" ref="select" collapse-tags multiple filterable :filter-method="regionFilter" @focus="changeSelectedCondition ">
          <el-option :label="`${item.name} (${item.pho})`" :value="item.customerId" v-for="item in selectItems" :key="item.customerId"></el-option>
        </el-select>
      </el-form-item> -->
      <el-form-item label="负责人：" >
        <el-select v-model="form.customerId" filterable remote placeholder="请输入手机号/姓名进行搜索" :remote-method="searchUsers" :loading="isLoading">
          <el-option v-for="item in chargeOptions" :key="item.userId" :label="item.realName + '('+ item.levelName+')'" :value="item.tableId">
          </el-option>
        </el-select>
      </el-form-item>
      <!-- <el-form-item label="手机号码：" prop="pho">
        <el-input v-model="form.pho" placeholder="请输入手机号码" maxlength="11" />
      </el-form-item> -->
      <el-form-item label="所在区域：" prop="addr">
        <el-cascader v-model="form.addr" :props="cascaderProps" collapse-tags :options="addressList" clearable placeholder="请选择省市区"></el-cascader>
      </el-form-item>
      <el-form-item label="详细地址：" prop="addrDetail">
        <el-input v-model="form.addrDetail" placeholder="请输入详细地址" />
      </el-form-item>
      <el-form-item label="管辖区域："  v-if="!form.id">
        <el-cascader v-model="form.cityCompanyAddrAreaList" :props="cascaderProps1" collapse-tags :options="technicianAreOptions" clearable popper-class="cascader-box"></el-cascader>
      </el-form-item>
      <el-form-item label="入驻时间：" prop="checkInTime">
        <el-date-picker v-model="form.checkInTime" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择入驻时间">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="状态：" prop="state" required>
        <el-switch v-model="form.state" :active-value="true" :inactive-value="false"></el-switch>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="formVisible = false">
        取消
      </el-button>
      <el-button type="primary" @click="doCreate()" :loading="isLoading">
        确认
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import cityCompanyApi from '@/api/sys/cityCompany'
import courseSubjectBarrierStudentApi from '@/api/course/courseSubjectBarrierStudent'
import CityCompanyAddrAreaApi from '@/api/sys/CityCompanyAddrArea'
function initFormBean() {
  const formBean = {
    name: null,
    areaId: null,
    // chargeName: null,
    // pho: null,
    addrDetail: null,
    customerId: null,
    state: true,
    cityCompanyAddrAreaList: []
  }
  return formBean
}

export default {
  props: {
    addressList: Array
  },
  data() {
    return {
      form: initFormBean(),
      isLoading: false,
      formVisible: false,
      selectItems: [],
      formRules: {
        name: [{
          required: true,
          message: '请输入城市公司名称',
          trigger: 'blur'
        }],
        areaId: [{
          required: true,
          message: '请输入选择大区',
          trigger: 'change'
        }],
        // chargeName: [{
        //   required: true,
        //   message: '请输入姓名',
        //   trigger: 'blur'
        // }],
        // pho: [{
        //   required: true,
        //   message: '请输入手机号码',
        //   trigger: 'blur'
        // }],
        addr: [{
          required: true,
          message: '请选择区域',
          trigger: 'change'
        }],
        addrDetail: [{
          required: true,
          message: '请输入详细地址',
          trigger: 'blur'
        }],
        checkInTime: [{
          required: true,
          message: '请选择入驻时间',
          trigger: 'change'
        }],
        customerId: [{
          required: true,
          message: '请选择负责人',
          trigger: 'change'
        }],
        cityCompanyAddrAreaList: [{
          required: true,
          message: '请选择管辖区域',
          trigger: 'change'
        }]
      },
      options: {
        projectList: [], //   正在开展项目
        storeTypeList: [], //门店类型
        frequencyList: [], //日均门诊人次
        staffNum: [] //员工数量
      },
      chargeOptions: [],
      cascaderProps: {
        label: 'regionName',
        value: 'regionCode',
        children: 'child',
      },
      cascaderProps1: {
        label: 'areaName',
        value: 'areaCode',
        children: 'child',
        multiple: true
      },
      technicianAreOptions: []

    }
  },
  created() {
   
  },
  methods: {
    formatCascaderData(data) {
      for (var i = 0; i < data.length; i++) {
        if (data[i].child.length < 1) {
          // children若为空数组，则将children设为undefined
          data[i].child = undefined;
        } else {
          // children若不为空数组，则继续 递归调用 本方法
          this.formatCascaderData(data[i].child)
        }
      }
      return data
    },
    getCityCompanyTreeList() {
      CityCompanyAddrAreaApi.CityCompanyTreeList().then(res => {
        this.technicianAreOptions = this.formatCascaderData(res.data);
      })
    },
    searchUsers(query) {
      if (query !== '') {
        this.isLoading = true;
        // 模拟远程搜索，实际应用中应该是发起AJAX请求
        setTimeout(() => {
          this.isLoading = false;
          courseSubjectBarrierStudentApi.fetchUsers({ keyWords: query, type: 1, pageNo: 1, pageSize: 100 }).then(data => {
            this.chargeOptions = data.data.list;
          })
        }, 500);
      } else {
        this.chargeOptions = [];
      }
    },
    changeSelectedCondition() {
      this.$refs['select'].$refs.input.blur = () => {
        this.getOption()
      }
    },
    regionFilter(e) {
      if (e) {
        this.getOption(e)
      }
    },
    // 获取大区
    getOption(e) {
      let query = {
        cityCompanyId: this.form.id ? this.form.id : 0,
        nameOrPho: e,
        pageNo: 1,
        pageSize: 100
      }
      cityCompanyApi.getListForMini(query).then(({
        data
      }) => {
        this.selectItems = data.list
      })
    },
    resetForm() {
      this.form = initFormBean()
    },
    handleCreate({
      id,
      type,
      row
    }) {
      console.log('row: ', id, type);
      this.resetForm()
      this.getCityCompanyTreeList()
      this.formVisible = true
      this.$nextTick(async () => {
        this.$refs['dataForm'].clearValidate()
        if (type) {
          const {
            data
          } = await cityCompanyApi.fetchById(id)
          this.form = {
            ...data
          }
          if (data && data.customerPO) {
            let { id, name } = data.customerPO
            this.chargeOptions = [{ tableId: id, realName: name, levelName: data.customerLevelName }]
          }
          this.form.addr = [data.addrProvinceCode, data.addrCityCode, data.addrAreaCode]
          let arr = data.areaList.map(i => (i.customerAreaId))
          this.$set(this.form, 'areaId', arr)
          console.log('this.form: ', this.form);
        }
        this.getOption()
      })
    },
    doCreate() {
      this.$refs["dataForm"].validate((valid) => {
        if (valid) {
          this.isLoading = true
          let params = {
            ...this.form
          }
          // console.log('params: ',params);
          // return
          params.addrProvinceCode = this.form.addr[0]
          params.addrCityCode = this.form.addr[1]
          params.addrAreaCode = this.form.addr[2]
          params.areaId = 0
          params.cityCompanyAddrAreaList = params.cityCompanyAddrAreaList && params.cityCompanyAddrAreaList.length > 0 ? params.cityCompanyAddrAreaList.map(i => {
            return { provinceCode: i[0], cityCode: i[1], districtCode: i[2], areaType: 3 }
          }) : null
          delete params.addr
          if (this.form.id) {
            cityCompanyApi.update(params).then((data) => {
              this.postCallback(data)
            }).catch(res => {
              this.isLoading = false
            });
          } else {
            cityCompanyApi.create(params).then((data) => {
              this.postCallback(data)
            }).catch(res => {
              this.isLoading = false
            });
          }
        }
      });
    },
    postCallback(data) {
      this.$message.success('操作成功')
      this.formVisible = false;
      this.$emit('created')
      this.isLoading = false
    },
  }
}
</script>
<style lang="scss" scoped>
::v-deep .el-select {
  width: 100%;
}

::v-deep .el-cascader {
  width: 100%;
}

::v-deep .el-input {
  width: 100%;
}

.el-form-item--small.el-form-item {
  width: 48%;
  display: inline-block;
  vertical-align: top;
}

.el-date-editor--datetimerange.el-input,
.el-date-editor--datetimerange.el-input__inner {
  width: 100%;
}

.el-form-item--small.el-form-item.width100 {
  width: 97%;
}
</style>
